import { Container, Grid, Typography } from '@mui/material';
import { MainSimpleViewLoader } from '../../libraries/MainViewLoader';
import { MasterViewPage } from '../MasterPage';

export const AppSettings = () => {
    return <MasterViewPage>
        <MainSimpleViewLoader
            path='setting'
        >
            <LoadedAppSettings />
        </MainSimpleViewLoader>
    </MasterViewPage>;
};

const LoadedAppSettings = () => {
    return <Container>
        <Grid container>
            <Grid item xs={12}>
                <Typography variant='h1'>Paramètres d'application</Typography>
            </Grid>
            <Grid item xs={12} md={6} lg={4} p={2} bgcolor={'white'} >
                <Typography variant='h4'>À venir</Typography>
            </Grid>
        </Grid>
    </Container>;
};
